import React, { useRef } from 'react';
// eslint-disable-next-line no-restricted-imports
import { useWatch } from 'react-hook-form-v7';
import CollapsibleFilterWrapper from '../CollapsibleFilterWrapper';
import ConnectedDateRangePicker, { getDateRangePickerInputNames } from './ConnectedDateRangePicker';

const CollapsibleDateRange = ({ control, name, label, tooltip, disabled = false }) => {
    const dateRangePickerRef = useRef(null);
    const { inputNameFrom, inputNameTo } = getDateRangePickerInputNames(name);

    const [dateFrom, dateTo] = useWatch({ control, name: [inputNameFrom, inputNameTo] });

    const handleReset = () => dateRangePickerRef.current.clear(); // TODO: Add reset to default values logic

    return (
        <CollapsibleFilterWrapper
            label={`${label} (${dateFrom || dateTo ? 1 : 0})`}
            onReset={handleReset}
            tooltip={tooltip}
            disabled={disabled}
        >
            <ConnectedDateRangePicker
                ref={dateRangePickerRef}
                control={control}
                name={name}
                disabled={disabled}
            />
        </CollapsibleFilterWrapper>
    );
};

export default CollapsibleDateRange;
